import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { PositionIcon } from '@sorare/core/src/components/lineup/PositionIcon';

import type { PlaceholderSlot_userCardCollectionSlot } from './__generated__/index.graphql';

const CardWrapper = styled(Vertical).attrs({ center: true })`
  border-radius: var(--unit);
  overflow: hidden;
  position: relative;
  border: 1px solid var(--c-nd-50);
  gap: var(--unit);
  height: 100%;
  aspect-ratio: var(--card-aspect-ratio);
  & > svg {
    color: var(--c-nd-600);
  }
`;

type Props = {
  slot: PlaceholderSlot_userCardCollectionSlot;
};

export const PlaceholderSlot = ({ slot }: Props) => {
  const { slot: collectionSlot } = slot;
  const { shirtNumber } = collectionSlot?.anyPlayer || {};
  const position = collectionSlot?.anyPlayer?.anyPositions?.[0];

  return (
    <CardWrapper>
      {position ? <PositionIcon position={position} size={2} /> : null}
      {typeof shirtNumber === 'number' && (
        <LabelS bold color="var(--c-nd-600)">
          #{shirtNumber.toString().padStart(2, '0')}
        </LabelS>
      )}
    </CardWrapper>
  );
};

PlaceholderSlot.fragments = {
  userCardCollectionSlot: gql`
    fragment PlaceholderSlot_userCardCollectionSlot on UserCardCollectionSlot {
      slug
      slot {
        id
        anyPlayer {
          slug
          anyPositions
          shirtNumber
        }
      }
    }
  ` as TypedDocumentNode<PlaceholderSlot_userCardCollectionSlot>,
};
